
// Selected from data using Rainbow CSV extension for VSCode with:
// SELECT parseFloat(a2).toFixed(3), parseFloat(a3).toFixed(3), Math.round(parseFloat(a5)), a6 ? Math.round(parseFloat(a6)) : "undefined" WHERE Math.round(parseFloat(a5)) > 0

import { RawHydroPowerPlantData } from "./interface"


export const hydro_plants_data: RawHydroPowerPlantData[] = [
[56.251,-4.712,153,undefined],
[56.693,-4.402,44,undefined],
[56.713,-4.958,24,undefined],
[56.830,-5.070,82,undefined],
[57.463,-4.512,20,undefined],
[57.457,-4.545,20,undefined],
[57.186,-4.482,2,undefined],
[57.619,-4.831,19,undefined],
[57.943,-4.411,19,undefined],
[56.373,-4.041,4,undefined],
[56.485,-4.363,45,undefined],
[52.396,-3.900,41,undefined],
[57.063,-5.124,19,undefined],
[56.953,-4.182,3,undefined],
[52.945,-3.668,5,undefined],
[56.482,-4.299,17,undefined],
[57.685,-5.643,1,undefined],
[57.137,-4.643,100,undefined],
[56.542,-4.517,4,undefined],
[56.547,-4.430,11,undefined],
[53.066,-4.011,10,undefined],
[56.699,-3.740,15,undefined],
[57.326,-4.794,69,undefined],
[56.717,-3.778,61,undefined],
[56.277,-4.922,40,undefined],
[56.621,-5.529,4,undefined],
[52.936,-4.004,30,undefined],
[56.910,-4.985,2,undefined],
[57.255,-4.493,5,undefined],
[58.169,-4.728,10,undefined],
[58.029,-4.415,4,undefined],
[58.013,-4.402,19,undefined],
[57.575,-4.687,34,undefined],
[57.628,-4.798,19,undefined],
[57.616,-4.833,3,undefined],
[57.554,-4.615,18,undefined],
[50.507,-4.191,1,undefined],
[55.100,-4.186,24,undefined],
[56.307,-4.861,6,undefined],
[52.975,-3.946,1,undefined],
[55.144,-4.189,12,undefined],
[58.260,-4.983,4,undefined],
[52.981,-3.968,360,1300],
[56.273,-5.489,2,undefined],
[53.192,-3.842,32,undefined],
[56.394,-5.113,440,10000],
[57.262,-4.484,300,6300],
[56.706,-4.021,34,undefined],
[56.709,-4.006,75,undefined],
[52.431,-3.845,13,undefined],
[52.397,-3.921,1,undefined],
[55.185,-2.458,6,undefined],
[55.165,-4.191,24,undefined],
[54.860,-4.034,33,undefined],
[55.248,-4.327,2,undefined],
[55.476,-5.585,2,undefined],
[56.010,-5.120,8,undefined],
[56.337,-4.976,5,undefined],
[56.440,-5.218,25,undefined],
[57.205,-4.728,15,undefined],
[57.202,-4.721,38,undefined],
[57.154,-4.939,20,undefined],
[57.407,-4.845,38,undefined],
[57.426,-4.704,19,undefined],
[57.334,-4.955,2,undefined],
[57.764,-5.040,3,undefined],
[57.822,-5.051,3,undefined],
[56.343,-5.209,15,undefined],
[56.965,-4.423,5,undefined],
[56.824,-4.372,2,undefined],
[52.120,-3.767,4,undefined],
[50.587,-4.107,3,undefined],
[56.419,-4.521,1,undefined],
[56.558,-5.693,2,undefined],
[54.245,-3.004,4,undefined],
[56.796,-4.592,1,undefined],
[56.686,-5.507,1,undefined],
[57.650,-5.411,2,undefined],
[57.285,-5.565,1,undefined],
[56.877,-5.490,1,undefined],
[57.214,-4.449,3,undefined],
[56.713,-4.953,2,undefined],
[56.888,-4.577,3,undefined],
[56.253,-4.375,1,undefined],
[56.066,-5.336,6,undefined],
[56.678,-4.509,6,undefined],
[57.970,-5.063,1,undefined],
[57.678,-5.707,2,undefined],
[57.682,-5.533,2,undefined],
[57.423,-5.423,1,undefined],
[57.491,-5.259,2,undefined],
[57.376,-5.328,2,undefined],
[56.975,-5.120,1,undefined],
[57.404,-5.304,1,undefined],
[57.072,-4.917,1,undefined],
[57.316,-4.504,2,undefined],
[57.078,-5.305,1,undefined],
[56.174,-4.547,1,undefined],
[56.396,-4.123,17,undefined],
[56.447,-4.114,3,undefined],
[57.097,-4.072,1,undefined],
[53.465,-2.381,1,undefined],
[52.098,-3.789,2,undefined],
[56.681,-5.190,1,undefined],
[53.443,-2.410,1,undefined],
[57.744,-5.062,2,undefined],
[56.182,-3.570,1,undefined],
[57.072,-4.774,20,undefined],
[57.554,-4.598,15,undefined],
[57.056,-5.082,1,undefined],
[57.035,-4.808,1,undefined],
[53.687,-1.459,1,undefined],
]
